import copy from 'copy-to-clipboard'

import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

/**
 * Builds a shareable inbox URL for a given resource.
 *
 * The resource type and ID are encoded into an opaque Base64 token so that
 * internal model names (e.g. `Forms::Form`) are not exposed in the URL.
 *
 * @param inboxPath - The inbox todo path (e.g. from `navigation.inbox.todo.fullPath()`)
 * @param resourceType - The backend resource type (e.g. `Forms::Form`)
 * @param resourceId - The resource ID
 */
export const buildInboxShareUrl = (
  inboxPath: string,
  resourceType: string,
  resourceId: string
): string => {
  const token = btoa(`${resourceType}|${resourceId}`)
  return `${window.location.origin}${inboxPath}?task_ref=${token}`
}

/**
 * Copies a shareable inbox task link to the clipboard and shows a success flash.
 *
 * @param inboxPath - The inbox todo path (e.g. from `navigation.inbox.todo.fullPath()`)
 * @param resourceType - The backend resource type (e.g. `Forms::Form`)
 * @param resourceId - The resource ID
 */
export const copyInboxTaskLink = (
  inboxPath: string,
  resourceType: string,
  resourceId: string
): void => {
  copy(buildInboxShareUrl(inboxPath, resourceType, resourceId))
  app.setFlash({
    type: 'correct',
    message: i18n.t('common.copied'),
  })
}
